module.exports = __webpack_public_path__ + "static/media/cake.01ad616a.svg";